module.exports = __webpack_public_path__ + "079061174514381e147bbfbf27fb16cd.pdf";